import { Empty } from "antd";
import GovernmentCard from "../gepeg";
import { useTranslation } from "react-i18next";

export default function GepgHistoryList({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <GovernmentCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
